module.exports = __webpack_public_path__ + "img/life_insurance.0d74508.svg";